<!-- 赠送活动成功弹窗 - Redemption Successful 升级对比版 -->
<template>
    <div class="popup" v-if="giveawaySucShow" id="giveawaySucPopup">
        <div class="giveaway-content" id="giveawaySuc" v-show="contentShow" :style="'transform: scale('+screenWidthRatio+');'">
            <!-- 关闭按钮 -->
            <div class="giveaway-close-btn" @click="closePage()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M1 1L13 13M13 1L1 13" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
            </div>
            <!-- 顶部标题栏 -->
            <div class="giveaway-header">
                <div class="giveaway-header-text">
                    <div class="giveaway-header-title">
                      <img class="giveaway-header-icon" :src="require('../../../assets/images/giveaway/260611/ic-40-keys.svg')" alt="keys">
                      {{ $t('language.popup.giveawayActiveSucPopup.headerTitle') }}
                    </div>
                    <div class="giveaway-header-subtitle">{{ planText('headerSubtitle') }}</div>
                </div>
            </div>
            <!-- 主体对比区域 -->
            <div class="giveaway-body">
                <div class="giveaway-compare">
                    <!-- 左侧卡片 -->
                    <div class="compare-card compare-card-left">
                        <div class="compare-card-title">{{ planText('currentPlanName') }}</div>
                        <div class="compare-card-status">
                            <img :src="require('../../../assets/images/giveaway/260611/ic-16-activated.svg')" alt="activated">
                            <span>{{ $t('language.popup.giveawayActiveSucPopup.currentPlanBadge') }}</span>
                        </div>
                        <ul class="compare-features">
                            <li class="compare-feature-item">
                                <img :src="require('../../../assets/images/giveaway/260611/ic-gou-blue.svg')" alt="check">
                                <span>{{ planText('feature1') }}</span>
                            </li>
                            <li class="compare-feature-item">
                                <img :src="require('../../../assets/images/giveaway/260611/ic-gou-blue.svg')" alt="check">
                                <span>{{ planText('feature2', { 'traffic': giveawayTraffic }) }}</span>
                            </li>
                            <li class="compare-feature-item">
                                <img :src="require('../../../assets/images/giveaway/260611/ic-gou-blue.svg')" alt="check">
                                <span>{{ $t('language.popup.giveawayActiveSucPopup.feature3') }}</span>
                            </li>
                        </ul>
                    </div>
                    <!-- 中间箭头 -->
                    <div class="compare-arrow">
                        <img :src="require('../../../assets/images/giveaway/260611/img-jiantou.png')" alt="arrow">
                    </div>
                    <!-- 右侧卡片 -->
                    <div class="compare-card compare-card-right">
                        <div class="compare-card-title">{{ $t('language.popup.giveawayActiveSucPopup.upgradePlanName') }}</div>
                        <div class="compare-card-price-all-row">
                            <div class="compare-card-price-row">
                              <span class="price-symbol">$</span>
                              <span class="price-current">{{ $t('language.popup.giveawayActiveSucPopup.upgradePlanCurrentPrice') }}</span>
                              <span class="price-original">{{ $t('language.popup.giveawayActiveSucPopup.upgradePlanOriginalPrice') }}</span>
                            </div>
                            <img :src="require('../../../assets/images/giveaway/260611/80-off.png')" alt="check">
                        </div>
                        <ul class="compare-features">
                            <li class="compare-feature-item">
                                <img :src="require('../../../assets/images/giveaway/260611/ic-gou-red.svg')" alt="check">
                                <span v-html="$t('language.popup.giveawayActiveSucPopup.featureUpgrade1')"></span>
                            </li>
                            <li class="compare-feature-item">
                                <img :src="require('../../../assets/images/giveaway/260611/ic-gou-red.svg')" alt="check">
                                <span v-html="$t('language.popup.giveawayActiveSucPopup.featureUpgrade2')"></span>
                            </li>
                            <li class="compare-feature-item">
                                <img :src="require('../../../assets/images/giveaway/260611/ic-gou-red.svg')" alt="check">
                                <span v-html="$t('language.popup.giveawayActiveSucPopup.featureUpgrade3')"></span>
                            </li>
                            <li class="compare-feature-item">
                                <img :src="require('../../../assets/images/giveaway/260611/ic-gou-red.svg')" alt="check">
                                <span v-html="$t('language.popup.giveawayActiveSucPopup.featureUpgrade4')"></span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 升级按钮 -->
                <div class="giveaway-upgrade-btn">
                    <button @click="handleUpgrade()">{{ $t('language.popup.giveawayActiveSucPopup.btnUpgrade') }}</button>
                </div>
                <!-- 倒计时 -->
                <div class="giveaway-countdown" v-if="countdownSeconds > 0">
                    <span class="countdown-label">{{ $t('language.popup.giveawayActiveSucPopup.countdownLabel') }}</span>
                    <span class="countdown-highlight">{{ countdownMinutes }} min : {{ countdownSecondsDisplay }} sec</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    props: {
        isOneYearGiveaway: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            giveawaySucShow: false,
            contentShow: false,
            giveawayTraffic: '200 GB',
            giveawayExpireTime: '',
            screenWidth: null,
            user: commonUtils.getUser(),
            // 倒计时相关
            countdownSeconds: 15 * 60,
            countdownTimer: null,
        }
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        };
        this.contentShow = true;
    },
    beforeDestroy() {
        this.stopCountdown();
    },
    computed: {
        screenWidthRatio: function() {
            if (this.screenWidth > 1920) {
                return 1;
            } else if (this.screenWidth > 1440) {
                return this.screenWidth / 1920;
            } else {
                return 0.8;
            }
        },
        countdownMinutes() {
            return String(Math.floor(this.countdownSeconds / 60)).padStart(2, '0');
        },
        countdownSecondsDisplay() {
            return String(this.countdownSeconds % 60).padStart(2, '0');
        }
    },
    watch: {
        contentShow(val) {
            if (val) {
                this.startCountdown();
            } else {
                this.stopCountdown();
            }
        }
    },
    methods: {
        planText(key, params) {
            const suffix = this.isOneYearGiveaway ? 'Year' : '';
            return this.$t('language.popup.giveawayActiveSucPopup.' + key + suffix, params);
        },
        closePage() {
            // 倒计时未结束时关闭弹窗，将剩余时间存入store，让left_banner显示促销卡片
            if (this.countdownSeconds > 0) {
                this.$store.commit('setPromoEndTime', Date.now() + this.countdownSeconds * 1000);
            }
            this.giveawaySucShow = false;
            this.contentShow = false;
            this.stopCountdown();
            if (this.$parent) {
                this.$parent.isShow = false;
            }
        },
        confirmAndClose() {
            this.closePage();
        },
        // 开始倒计时
        startCountdown() {
            this.stopCountdown();
            this.countdownTimer = setInterval(() => {
                if (this.countdownSeconds > 0) {
                    this.countdownSeconds--;
                } else {
                    this.stopCountdown();
                    this.closePage();
                }
            }, 1000);
        },
        // 停止倒计时
        stopCountdown() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
        },
        // 点击升级按钮
        handleUpgrade() {
          const lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
          const action = commonstate.cbLinkUrl+'/1901/purl-mc-cart?x-linkid='+lang+'';
          const item = {
              productId: "295118",
              coupon: "M78-CT2-7TG",
              xMb: 30,
              xLevel: 1,
              xPage: "",
          }
          const user = commonUtils.getUser();
          commonUtils.packageFormAndSubmit(action,item,user,item.productId);
          this.closePage();
        },
        showPopup(data) {
            if (data && data.traffic) {
                this.giveawayTraffic = data.traffic;
            }
            if (data && data.expireTime) {
                this.giveawayExpireTime = data.expireTime;
            }
            if (data && data.countdownSeconds) {
                this.countdownSeconds = data.countdownSeconds;
            }
            this.contentShow = true;
            this.giveawaySucShow = true;
            this.startCountdown();
        },
        hidePopup() {
            this.giveawaySucShow = false;
            this.contentShow = false;
            this.stopCountdown();
        }
    }
}
</script>

<style>
.popup {
    display: flex;
}

#giveawaySuc {
    width: 730Px;
    min-height: auto;
    margin: auto;
}

.giveaway-content {
    border-radius: 20Px;
    background: #FFFFFF;
    font-family: Arial, "Microsoft YaHei", sans-serif;
    position: relative;
    box-shadow: 0px 12px 40px 0px rgba(0, 0, 0, 0.18);
    overflow: hidden;
}

/* ========== 关闭按钮 ========== */
.giveaway-close-btn {
    position: absolute;
    right: 16Px;
    top: 16Px;
    width: 32Px;
    height: 32Px;
    border-radius: 50%;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;
    background: rgba(255, 255, 255, 0.15);
}

.giveaway-close-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}

/* ========== 顶部标题栏 ========== */
.giveaway-header {
    background: linear-gradient(135deg, #1A1B6C 0%, #2D2E8C 50%, #3B3D9E 100%);
    padding: 28Px 40Px 24Px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16Px;
}

.giveaway-header-icon {
    width: 40Px;
    height: 40Px;
    flex-shrink: 0;
}

.giveaway-header-text {
    display: flex;
    flex-direction: column;
    gap: 6Px;
}

.giveaway-header-title {
    font-size: 22Px;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 28Px;
    letter-spacing: 0.02em;
    text-align: center;
}

.giveaway-header-subtitle {
    font-size: 13Px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    line-height: 18Px;
}

/* ========== 主体区域 ========== */
.giveaway-body {
    padding: 32Px;
}

/* ========== 左右对比区域 ========== */
.giveaway-compare {
    display: flex;
    gap: 26Px;
    position: relative;
    align-items: center;
}

.compare-card {
    border-radius: 16Px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

/* 左侧卡片 */
.compare-card-left {
    background: #F0F2FF;
    border: 1Px solid #E0E3FA;
    padding: 24Px;
}

/* 右侧卡片 */
.compare-card-right {
    flex: 1;
    background: linear-gradient(180deg, #fff0fb 0%, #ffffff 35%);
    border: 2Px solid #E91E8C;
    padding: 40Px;
}

/* 中间箭头 */
.compare-arrow {
    position: absolute;
    left: 46%;
    top: 54%;
    transform: translate(-50%, -50%);
    z-index: 10;
    pointer-events: none;
}

.compare-arrow img {
    width: 86Px;
    height: auto;
}

/* 卡片标题 */
.compare-card-title {
    font-size: 20Px;
    font-weight: bold;
    color: #000000;
    line-height: 22Px;
    margin-bottom: 10Px;
}

/* Activated 状态 */
.compare-card-status {
    display: flex;
    align-items: center;
    gap: 6Px;
    margin-bottom: 12Px;
}

.compare-card-status img {
    width: 16Px;
    height: 16Px;
}

.compare-card-status span {
    font-size: 13Px;
    font-weight: 700;
    color: #4A5FE2;
}

/* 价格区（右侧卡片） */
.compare-card-price-all-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8Px;
}

.compare-card-price-row {
    display: flex;
    align-items: baseline;
    gap: 8Px;
    margin-bottom: 12Px;
    flex-wrap: nowrap;
}

.price-symbol {
    font-size: 18Px;
    font-weight: 600;
    background: linear-gradient(180deg, #ff1bfb 28%, #ff378b 84%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}

.price-current {
    font-size: 32Px;
    font-weight: 800;
    background: linear-gradient(180deg, #ff1bfb 28%, #ff378b 84%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    line-height: 36Px;
}

.price-original {
    font-size: 14Px;
    font-weight: 400;
    color: #000000;
    text-decoration: line-through;
}

/* 特性列表 */
.compare-features {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    margin-right: 12Px;
}

.compare-feature-item {
    display: flex;
    align-items: center;
    gap: 8Px;
    padding: 5Px 0;
    font-size: 14Px;
    font-weight: 400;
    color: #333333;
    line-height: 18Px;
}

.compare-feature-item img {
    width: 16Px;
    height: 16Px;
    flex-shrink: 0;
}

/* ========== 升级按钮 ========== */
.giveaway-upgrade-btn {
    display: flex;
    justify-content: center;
    margin-top: 24Px;
}

.giveaway-upgrade-btn button {
    width: 420Px;
    height: 48Px;
    background: linear-gradient(90deg, #FF6B9D 0%, #FF4081 100%);
    border-radius: 12Px;
    font-size: 16Px;
    font-weight: 700;
    font-family: Arial;
    color: #fff;
    border: none;
    cursor: pointer;
    transition: all 0.25s;
    box-shadow: 0px 6px 20px 0px rgba(255, 64, 129, 0.3);
}

.giveaway-upgrade-btn button:hover {
    background: linear-gradient(90deg, #FF85AD 0%, #FF5A99 100%);
    transform: translateY(-2Px);
    box-shadow: 0px 8px 24px 0px rgba(255, 64, 129, 0.4);
}

.giveaway-upgrade-btn button:active {
    transform: translateY(0);
    box-shadow: 0px 4px 12px 0px rgba(255, 64, 129, 0.25);
}

/* ========== 倒计时 ========== */
.giveaway-countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6Px;
    margin-top: 14Px;
    font-size: 13Px;
    font-weight: 400;
    color: #888888;
}

.countdown-label {
    color: #888888;
}

.countdown-highlight {
    color: #FF4081;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/giveaway_active_suc_popup.vue